import { constructs } from "../api/contructs";
import { CreateGenericReducer } from "./CreateGenericReducer";

export const PipelinesReducer = CreateGenericReducer(constructs.pipeline);
